import Input from '../../input/Input.esm.js';
import '../../input/PhoneInput.esm.js';
import React__default from 'react';
import ClientItem from './ClientItem.esm.js';
import { useProposalContext } from '../proposalContext.esm.js';
import t from '../../../services/translatorService.esm.js';

const SearchClient = ({
  search,
  setSearch,
  selectedClient,
  onSelectClient
}) => {
  const {
    state
  } = useProposalContext();
  const {
    clients
  } = state;
  const filteredClients = clients.filter(item => [item.firstName, item.lastName, item.phone, item.email].some(field => field.toLowerCase().includes(search.toLowerCase())));
  const onClientClick = id => {
    if (selectedClient === id) {
      onSelectClient(null);
    } else {
      onSelectClient(id);
    }
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: "mb-9"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "text-xl font-semibold mb-3 leading-none text-start"
  }, t('proposals.searchClient')), /*#__PURE__*/React__default.createElement(Input, {
    startIcon: /*#__PURE__*/React__default.createElement("i", {
      className: "ri-search-line"
    }),
    placeholder: t('proposals.searchClientPlaceholder'),
    value: search,
    onChange: e => setSearch(e.target.value)
  })), (search.length > 0 || selectedClient) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "text-xl font-semibold mb-6 leading-none"
  }, t('proposals.client')), /*#__PURE__*/React__default.createElement("div", {
    className: "flex flex-col gap-3"
  }, filteredClients.length > 0 && filteredClients.map(client => (/*#__PURE__*/React__default.createElement(ClientItem, {
    client: client,
    onClick: () => onClientClick(client.id),
    selected: selectedClient === client.id
  }))), filteredClients.length === 0 && /*#__PURE__*/React__default.createElement("div", {
    className: "p-5 bg-shark-50 text-sm text-shark-300 rounded-xl"
  }, "No results"))));
};
var SearchClient$1 = /*#__PURE__*/React__default.memo(SearchClient);

export { SearchClient$1 as default };
//# sourceMappingURL=SearchClient.esm.js.map
